// GENERATED by Phase 4C-2 final cleanup — extracted from Riz_Wedding_Menu_Photos.xlsx
// Keys are nkey(backend menu name). w/hh = master natural size. Never upscaled.
export const MENU_IMAGES = {
  "bhelpoori": {
    "t": "/menu-photos/v2/bhel-puri-t.webp",
    "c": "/menu-photos/v2/bhel-puri-c.webp",
    "h": "/menu-photos/v2/bhel-puri-h.webp",
    "jpg": "/menu-photos/v2/bhel-puri-c.jpg",
    "w": 353,
    "hh": 236,
    "fit": "contain"
  },
  "paanipoori": {
    "t": "/menu-photos/v2/pani-puri-t.webp",
    "c": "/menu-photos/v2/pani-puri-c.webp",
    "h": "/menu-photos/v2/pani-puri-h.webp",
    "jpg": "/menu-photos/v2/pani-puri-c.jpg",
    "w": 174,
    "hh": 232,
    "fit": "contain"
  },
  "alootikkichaat": {
    "t": "/menu-photos/v2/aloo-tikki-chaat-t.webp",
    "c": "/menu-photos/v2/aloo-tikki-chaat-c.webp",
    "h": "/menu-photos/v2/aloo-tikki-chaat-h.webp",
    "jpg": "/menu-photos/v2/aloo-tikki-chaat-c.jpg",
    "w": 241,
    "hh": 242,
    "fit": "contain"
  },
  "samosachaat": {
    "t": "/menu-photos/v2/samosa-chaat-t.webp",
    "c": "/menu-photos/v2/samosa-chaat-c.webp",
    "h": "/menu-photos/v2/samosa-chaat-h.webp",
    "jpg": "/menu-photos/v2/samosa-chaat-c.jpg",
    "w": 230,
    "hh": 229,
    "fit": "contain"
  },
  "chickentikka": {
    "t": "/menu-photos/v2/chicken-tikka-t.webp",
    "c": "/menu-photos/v2/chicken-tikka-c.webp",
    "h": "/menu-photos/v2/chicken-tikka-h.webp",
    "jpg": "/menu-photos/v2/chicken-tikka-c.jpg",
    "w": 357,
    "hh": 239,
    "fit": "contain"
  },
  "haryalitikka": {
    "t": "/menu-photos/v2/haryali-tikka-t.webp",
    "c": "/menu-photos/v2/haryali-tikka-c.webp",
    "h": "/menu-photos/v2/haryali-tikka-h.webp",
    "jpg": "/menu-photos/v2/haryali-tikka-c.jpg",
    "w": 159,
    "hh": 240,
    "fit": "contain"
  },
  "chilipaneerontawa": {
    "t": "/menu-photos/v2/chili-paneer-on-tawa-t.webp",
    "c": "/menu-photos/v2/chili-paneer-on-tawa-c.webp",
    "h": "/menu-photos/v2/chili-paneer-on-tawa-h.webp",
    "jpg": "/menu-photos/v2/chili-paneer-on-tawa-c.jpg",
    "w": 153,
    "hh": 229,
    "fit": "contain"
  },
  "hakkanoodles": {
    "t": "/menu-photos/v2/hakka-noodles-t.webp",
    "c": "/menu-photos/v2/hakka-noodles-c.webp",
    "h": "/menu-photos/v2/hakka-noodles-h.webp",
    "jpg": "/menu-photos/v2/hakka-noodles-c.jpg",
    "w": 238,
    "hh": 239,
    "fit": "contain"
  },
  "vegmanchurian": {
    "t": "/menu-photos/v2/veg-manchurian-t.webp",
    "c": "/menu-photos/v2/veg-manchurian-c.webp",
    "h": "/menu-photos/v2/veg-manchurian-h.webp",
    "jpg": "/menu-photos/v2/veg-manchurian-c.jpg",
    "w": 239,
    "hh": 240,
    "fit": "contain"
  },
  "kungpaochilichicken": {
    "t": "/menu-photos/v2/kung-pao-chili-chicken-t.webp",
    "c": "/menu-photos/v2/kung-pao-chili-chicken-c.webp",
    "h": "/menu-photos/v2/kung-pao-chili-chicken-h.webp",
    "jpg": "/menu-photos/v2/kung-pao-chili-chicken-c.jpg",
    "w": 152,
    "hh": 229,
    "fit": "contain"
  },
  "shrimpsaute": {
    "t": "/menu-photos/v2/shrimp-saute-t.webp",
    "c": "/menu-photos/v2/shrimp-saute-c.webp",
    "h": "/menu-photos/v2/shrimp-saute-h.webp",
    "jpg": "/menu-photos/v2/shrimp-saute-c.jpg",
    "w": 160,
    "hh": 242,
    "fit": "contain"
  },
  "chickensaute": {
    "t": "/menu-photos/v2/chicken-saute-t.webp",
    "c": "/menu-photos/v2/chicken-saute-c.webp",
    "h": "/menu-photos/v2/chicken-saute-h.webp",
    "jpg": "/menu-photos/v2/chicken-saute-c.jpg",
    "w": 161,
    "hh": 243,
    "fit": "contain"
  },
  "lambchop": {
    "t": "/menu-photos/v2/lamb-chop-t.webp",
    "c": "/menu-photos/v2/lamb-chop-c.webp",
    "h": "/menu-photos/v2/lamb-chop-h.webp",
    "jpg": "/menu-photos/v2/lamb-chop-c.jpg",
    "w": 155,
    "hh": 234,
    "fit": "contain"
  },
  "fishkoliwada": {
    "t": "/menu-photos/v2/fish-koliwada-t.webp",
    "c": "/menu-photos/v2/fish-koliwada-c.webp",
    "h": "/menu-photos/v2/fish-koliwada-h.webp",
    "jpg": "/menu-photos/v2/fish-koliwada-c.jpg",
    "w": 143,
    "hh": 256,
    "fit": "contain"
  },
  "cutmirchipoppers": {
    "t": "/menu-photos/v2/cut-mirchi-poppers-t.webp",
    "c": "/menu-photos/v2/cut-mirchi-poppers-c.webp",
    "h": "/menu-photos/v2/cut-mirchi-poppers-h.webp",
    "jpg": "/menu-photos/v2/cut-mirchi-poppers-c.jpg",
    "w": 578,
    "hh": 346,
    "fit": "cover"
  },
  "masalagnocchi": {
    "t": "/menu-photos/v2/masala-gnocchi-t.webp",
    "c": "/menu-photos/v2/masala-gnocchi-c.webp",
    "h": "/menu-photos/v2/masala-gnocchi-h.webp",
    "jpg": "/menu-photos/v2/masala-gnocchi-c.jpg",
    "w": 157,
    "hh": 237,
    "fit": "contain"
  },
  "vegburratalollipop": {
    "t": "/menu-photos/v2/veg-burrata-lollipop-t.webp",
    "c": "/menu-photos/v2/veg-burrata-lollipop-c.webp",
    "h": "/menu-photos/v2/veg-burrata-lollipop-h.webp",
    "jpg": "/menu-photos/v2/veg-burrata-lollipop-c.jpg",
    "w": 113,
    "hh": 142,
    "fit": "contain"
  },
  "chefsalad": {
    "t": "/menu-photos/v2/chef-s-salad-t.webp",
    "c": "/menu-photos/v2/chef-s-salad-c.webp",
    "h": "/menu-photos/v2/chef-s-salad-h.webp",
    "jpg": "/menu-photos/v2/chef-s-salad-c.jpg",
    "w": 159,
    "hh": 240,
    "fit": "contain"
  },
  "patranifish": {
    "t": "/menu-photos/v2/partrani-fish-t.webp",
    "c": "/menu-photos/v2/partrani-fish-c.webp",
    "h": "/menu-photos/v2/partrani-fish-h.webp",
    "jpg": "/menu-photos/v2/partrani-fish-c.jpg",
    "w": 517,
    "hh": 386,
    "fit": "cover"
  },
  "dahivada": {
    "t": "/menu-photos/v2/dahi-vada-t.webp",
    "c": "/menu-photos/v2/dahi-vada-c.webp",
    "h": "/menu-photos/v2/dahi-vada-h.webp",
    "jpg": "/menu-photos/v2/dahi-vada-c.jpg",
    "w": 200,
    "hh": 200,
    "fit": "cover"
  },
  "fruitpalatecleanser": {
    "t": "/menu-photos/v2/fruit-palate-cleanser-t.webp",
    "c": "/menu-photos/v2/fruit-palate-cleanser-c.webp",
    "h": "/menu-photos/v2/fruit-palate-cleanser-h.webp",
    "jpg": "/menu-photos/v2/fruit-palate-cleanser-c.jpg",
    "w": 500,
    "hh": 500,
    "fit": "cover"
  },
  "freshseekhkabab": {
    "t": "/menu-photos/v2/fresh-seekh-kabab-t.webp",
    "c": "/menu-photos/v2/fresh-seekh-kabab-c.webp",
    "h": "/menu-photos/v2/fresh-seekh-kabab-h.webp",
    "jpg": "/menu-photos/v2/fresh-seekh-kabab-c.jpg",
    "w": 547,
    "hh": 365,
    "fit": "cover"
  },
  "butterchicken": {
    "t": "/menu-photos/v2/butter-chicken-t.webp",
    "c": "/menu-photos/v2/butter-chicken-c.webp",
    "h": "/menu-photos/v2/butter-chicken-h.webp",
    "jpg": "/menu-photos/v2/butter-chicken-c.jpg",
    "w": 242,
    "hh": 242,
    "fit": "contain"
  },
  "lambroganjosh": {
    "t": "/menu-photos/v2/lamb-rogan-josh-t.webp",
    "c": "/menu-photos/v2/lamb-rogan-josh-c.webp",
    "h": "/menu-photos/v2/lamb-rogan-josh-h.webp",
    "jpg": "/menu-photos/v2/lamb-rogan-josh-c.jpg",
    "w": 161,
    "hh": 234,
    "fit": "contain"
  },
  "palakpaneer": {
    "t": "/menu-photos/v2/palak-paneer-t.webp",
    "c": "/menu-photos/v2/palak-paneer-c.webp",
    "h": "/menu-photos/v2/palak-paneer-h.webp",
    "jpg": "/menu-photos/v2/palak-paneer-c.jpg",
    "w": 222,
    "hh": 222,
    "fit": "contain"
  },
  "dalmakhani": {
    "t": "/menu-photos/v2/dal-makhani-t.webp",
    "c": "/menu-photos/v2/dal-makhani-c.webp",
    "h": "/menu-photos/v2/dal-makhani-h.webp",
    "jpg": "/menu-photos/v2/dal-makhani-c.jpg",
    "w": 229,
    "hh": 230,
    "fit": "contain"
  },
  "vegbiryani": {
    "t": "/menu-photos/v2/vegetable-biryani-t.webp",
    "c": "/menu-photos/v2/vegetable-biryani-c.webp",
    "h": "/menu-photos/v2/vegetable-biryani-h.webp",
    "jpg": "/menu-photos/v2/vegetable-biryani-c.jpg",
    "w": 354,
    "hh": 241,
    "fit": "contain"
  },
  "freshassortedbreadbasket": {
    "t": "/menu-photos/v2/fresh-assorted-bread-basket-t.webp",
    "c": "/menu-photos/v2/fresh-assorted-bread-basket-c.webp",
    "h": "/menu-photos/v2/fresh-assorted-bread-basket-h.webp",
    "jpg": "/menu-photos/v2/fresh-assorted-bread-basket-c.jpg",
    "w": 295,
    "hh": 244,
    "fit": "contain"
  },
  "dryfruithalwa": {
    "t": "/menu-photos/v2/dry-fruit-halwa-t.webp",
    "c": "/menu-photos/v2/dry-fruit-halwa-c.webp",
    "h": "/menu-photos/v2/dry-fruit-halwa-h.webp",
    "jpg": "/menu-photos/v2/dry-fruit-halwa-c.jpg",
    "w": 640,
    "hh": 427,
    "fit": "cover"
  },
  "doublekameeta": {
    "t": "/menu-photos/v2/double-ka-meetha-t.webp",
    "c": "/menu-photos/v2/double-ka-meetha-c.webp",
    "h": "/menu-photos/v2/double-ka-meetha-h.webp",
    "jpg": "/menu-photos/v2/double-ka-meetha-c.jpg",
    "w": 243,
    "hh": 242,
    "fit": "contain"
  },
  "freshjalebiwithrabdi": {
    "t": "/menu-photos/v2/fresh-jalebi-with-rabdi-t.webp",
    "c": "/menu-photos/v2/fresh-jalebi-with-rabdi-c.webp",
    "h": "/menu-photos/v2/fresh-jalebi-with-rabdi-h.webp",
    "jpg": "/menu-photos/v2/fresh-jalebi-with-rabdi-c.jpg",
    "w": 232,
    "hh": 242,
    "fit": "contain"
  },
  "cremebruleestation": {
    "t": "/menu-photos/v2/cre-me-bru-le-e-t.webp",
    "c": "/menu-photos/v2/cre-me-bru-le-e-c.webp",
    "h": "/menu-photos/v2/cre-me-bru-le-e-h.webp",
    "jpg": "/menu-photos/v2/cre-me-bru-le-e-c.jpg",
    "w": 638,
    "hh": 480,
    "fit": "cover"
  },
  "chaistation": {
    "t": "/menu-photos/v2/chai-station-t.webp",
    "c": "/menu-photos/v2/chai-station-c.webp",
    "h": "/menu-photos/v2/chai-station-h.webp",
    "jpg": "/menu-photos/v2/chai-station-c.jpg",
    "w": 447,
    "hh": 447,
    "fit": "contain"
  },
  "gunpowdervadapao": {
    "t": "/menu-photos/v2/grilled-cheese-vada-pav-t.webp",
    "c": "/menu-photos/v2/grilled-cheese-vada-pav-c.webp",
    "h": "/menu-photos/v2/grilled-cheese-vada-pav-h.webp",
    "jpg": "/menu-photos/v2/grilled-cheese-vada-pav-c.jpg",
    "w": 226,
    "hh": 233,
    "fit": "contain"
  },
  "milkshotswithcookies": {
    "t": "/menu-photos/v2/milk-shots-with-cookies-t.webp",
    "c": "/menu-photos/v2/milk-shots-with-cookies-c.webp",
    "h": "/menu-photos/v2/milk-shots-with-cookies-h.webp",
    "jpg": "/menu-photos/v2/milk-shots-with-cookies-c.jpg",
    "w": 323,
    "hh": 212,
    "fit": "contain"
  }
};
